import React from "react";
import classes from "./ButtonRow.css"


const infoRow = (props) => {

  // Only display element if show prop is true
  if (typeof(props.show) === "boolean") {
    if (props.show === false) {
      return null
    }
  }

  const outerClasses = [classes.rowContainer];
  if (props.firstRow === true) {
    outerClasses.push(classes.isFirstRow);
  }
  return (
    <div className={outerClasses.join(" ")}>
      <p className={classes.title}>{props.title}</p>
      <button className={classes.button} onClick={props.onClick}>{props.body}</button>
    </div>
  );
};


export default infoRow;
